(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Marketing', Marketing);

    Marketing.$inject = ['$resource'];

    function Marketing($resource) {
        // return $resource('api/register', {}, {});
        var marketingAttribution = function() {
            var resourceUrl = 'api/v2/marketing/attribution';
            return $resource(resourceUrl, {}, { });
        }

        return {
            marketingAttribution: marketingAttribution
        }
    }
})();
